import React, { useMemo } from 'react'

import { getSavedDetailsForOffer } from 'tripPlanner/components/Bookmark/BookmarkButton/utils'
import { useEditableTrips } from 'tripPlanner/hooks/api/trip'
import { EmptyArray } from 'lib/array/arrayUtils'
import SavePrompt from './SavePrompt'
import useNewTripNameFromOffer from 'tripPlanner/hooks/useNewTripNameFromOffer'
import { CruiseBookmarkPayload } from 'tripPlanner/api/bookmark/types'
import { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  offer: App.CruiseOffer
}

function SavePromptCruise({ offer }: Props) {
  const { data, isSuccess: tripsFetched } = useEditableTrips()
  const trips = data ?? EmptyArray as Array<BasicTrip>

  const details = getSavedDetailsForOffer(trips, offer.id)
  const isSaved = details.length > 0

  const newTripName = useNewTripNameFromOffer(offer)

  const bookmarkPayload = useMemo<CruiseBookmarkPayload>(() => ({
    type: 'cruise_v2',
    code: offer.id,
  }), [offer.id])

  if (isSaved || !tripsFetched) {
    return null
  }

  return <SavePrompt
    offerId={offer.id}
    offerTypeLabel="cruise"
    bookmarkPayload={bookmarkPayload}
    newTripName={newTripName}
    trips={trips}
  />
}

export default SavePromptCruise
